import CityPageTemplate from "../city-template/CityPageTemplate";
import { hudsonConfig } from "./data";

export default function HudsonPage() {
  return <CityPageTemplate config={hudsonConfig} />;
}